import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-settings-list',
  templateUrl: './settings-list.component.html',
  styleUrls: ['./settings-list.component.scss'],
  standalone: false
})
export class SettingsListComponent {

  @Input() title: string = '';

  @Input() items: any;
  @Output() itemClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  handleItemClick(item: any) {
    this.itemClicked.emit(item);
  }
}
